import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "el-text__primary" }, " Dashboards ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Manage and customized your dashboards. ", -1)
const _hoisted_3 = { class: "card-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_dashboard_layout = _resolveComponent("dashboard-layout")!

  return (_openBlock(), _createBlock(_component_dashboard_layout, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, {
        type: "flex",
        justify: "space-between",
        align: "middle"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      (_ctx.views.length > 0)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 20
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (view, index) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  key: index,
                  xs: 24,
                  sm: 24,
                  md: 6,
                  lg: 6,
                  xl: 6
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { style: {"margin-bottom":"25px"} }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_link, {
                            href: `/dashboards/${view.view_name}`,
                            type: "primary",
                            class: "el-capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(view.display_props.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["href"])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("p", null, _toDisplayString(view.view_description), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "No dashboards found"
          }))
    ]),
    _: 1
  }))
}